export const SIDEBAR_LOCALE_ZHCHS = {
    sidebar: 'è¯¦æ',
};
